import { ExpTimeType } from '../../../../components/HotlistModal/HotlistModal.types';
import { DefaultFieldsType } from './SingleHotlist.types';

export const expirationTimes: ExpTimeType[] = [
  {
    id: 0,
    text: '24 Hours',
    value: 86400,
  },
  {
    id: 1,
    text: '1 Week',
    value: 604800,
  },
  {
    id: 2,
    text: '1 Month',
    value: 2592000,
  },
  {
    id: 3,
    text: 'Unlimited',
    value: 0,
  },
];

export const initFieldsForDef: DefaultFieldsType = { states: [], alertTypes: [], expTime: [], clients: [], cameras: [] };
